// @ts-strict-ignore
import {Component, input, signal, TemplateRef} from "@angular/core";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {MatRipple} from "@angular/material/core";
import {NgTemplateOutlet} from "@angular/common";
import {IId} from "@models";
import {ChevronOverflowComponent} from "@common/ui/chevron-overflow/chevron-overflow.component";
import {Translations} from "@translations";
import {TranslateModule} from "@ngx-translate/core";

@Component({
	selector: "sim-session-station-preview",
	templateUrl: "./session-station-preview.component.html",
	styleUrl: "./session-station-preview.component.scss",
	imports: [MatTabGroup, MatTab, MatRipple, NgTemplateOutlet, ChevronOverflowComponent, TranslateModule],
})
export class SessionStationPreviewComponent<T extends IId> {
	// I/O
	public stations = input.required<T[]>();
	public contentTemplate = input.required<TemplateRef<{$implicit: {station: T; index: number}}>>();

	// Properties
	public activeStationIndex = signal<number>(0);

	// 	Constants
	protected readonly T = Translations;
}
